import React from 'react';
import { useNavigate ,Link} from 'react-router-dom';
import logoSvg from "../../../assets/chanakyaLogo.svg";
import './styles.css';
import { toast } from 'react-toastify';
import axios from 'axios';
import { ApiCollection } from '../../../config/envConfig';

const ForgotPassword: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [emailError, setEmailError] = React.useState('');

  const validateEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setEmailError('');
    
    if (!email) {
      setEmailError('Please enter your email address');
      return;
    }

    if (!validateEmail(email)) {
      setEmailError('Please enter a valid email address');
      return;
    }

    try {
      setLoading(true);
      
      const response = await axios.post(ApiCollection.user.forgotPassword, {
        email: email
      });

      const successMessage = response.data?.message;
      toast.success(successMessage);
      navigate('/login');
    } catch (error: any) {
      const errorMessage = error.response?.data?.detail || 'Failed to send reset link';
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
    setEmailError('');
  };

  return (
    <div className="forgot-password-page">
      <div className="forgot-password-container">
        <img
          src={logoSvg}
          alt="Logo"
          className="forgot-password-logo"
        />
        
        <div className="forgot-password-content">
          <h1>Forgot Password?</h1>
          <p>Enter your email address and we'll send you a link to reset your password.</p>

          <form onSubmit={handleSubmit} className="forgot-password-form">
            <div className="form-group">
              <label>Email Address</label>
              <input
                type="text"
                placeholder="Enter your email"
                value={email}
                onChange={handleEmailChange}
                className={emailError ? 'error' : ''}
              />
              {emailError && <span className="error-message">{emailError}</span>}
            </div>

            <button type="submit" disabled={loading}>
              {loading ? (
                <div className="spinner"></div>
              ) : (
                'Send Reset Link'
              )}
            </button>

            <div className="back-to-login">
              <Link to="/">← Back to Login</Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword; 